import { HTMLAttributes } from "react";
import { styled } from "styled-components";

import { colors, Icon, Text } from "@vericus/cadmus-ui";

export interface SidebarButtonProps extends HTMLAttributes<HTMLButtonElement> {
  icon: "Plus" | "Home";
}

export const SidebarButton = (props: SidebarButtonProps) => {
  const { icon, children } = props;
  return (
    <Button {...props} icon={icon}>
      <Icon iconName={icon} />
      <Text kind="bodyLine" as="span">
        {children}
      </Text>
    </Button>
  );
};

const Button = styled.button<SidebarButtonProps>`
  width: 100%;
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  gap: 8px;

  transition: background-color 0.1s ease-out;
  padding: 8px 16px;
  box-sizing: border-box;

  ${Icon} {
    fill: ${colors.black200};
    width: 24px;
    height: 24px;
  }
  ${Text} {
    color: ${colors.black200};
    font-size: 16px;
    line-height: 1.5;
  }

  &:hover {
    background-color: ${colors.grey50};
  }
  &:focus {
    outline: none;
    ${(p) => p.theme.focusInset};
  }
`;
